export default[
  'CO',
  'CT',
  'WV',
  'NH',
  'ND',
  'VT',
  'IA',
  'KS',
  'MS',
  'MD',
  'SC',
  'WA',
  'WI',
  'VI',
  'PR',
  'WY',
];



// WEBPACK FOOTER //
// ./src/utils/unSupportedStates.js